import { render, staticRenderFns } from "./XMLReport.vue?vue&type=template&id=1977e086&scoped=true"
import script from "./XMLReport.vue?vue&type=script&lang=js"
export * from "./XMLReport.vue?vue&type=script&lang=js"
import style0 from "./XMLReport.vue?vue&type=style&index=0&id=1977e086&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1977e086",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
